"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _HBBaseTag = _interopRequireDefault(require("../HBBaseTag/HBBaseTag"));
var _colors = _interopRequireDefault(require("../../styles/colors"));
var HBTagNew = function HBTagNew(props) {
  var _props$theme = props.theme,
    theme = _props$theme === void 0 ? 'neutral' : _props$theme,
    _props$size = props.size,
    size = _props$size === void 0 ? 'sm' : _props$size,
    label = props.label,
    prefixIcon = props.prefixIcon,
    onClick = props.onClick,
    onEdit = props.onEdit,
    onRemove = props.onRemove;
  var baseProps = {
    label: label,
    size: size,
    prefixIcon: prefixIcon,
    isSquare: false,
    isSelected: false,
    theme: THEME[theme],
    padding: size === 'sm' ? '0 8px' : '0 12px'
  };
  if (onRemove) {
    return /*#__PURE__*/_react["default"].createElement(_HBBaseTag["default"], (0, _extends2["default"])({}, baseProps, {
      onRemove: onRemove
    }));
  }
  if (onEdit) {
    return /*#__PURE__*/_react["default"].createElement(_HBBaseTag["default"], (0, _extends2["default"])({}, baseProps, {
      onEdit: onEdit
    }));
  }
  if (onClick) {
    return /*#__PURE__*/_react["default"].createElement(_HBBaseTag["default"], (0, _extends2["default"])({}, baseProps, {
      onClick: onClick
    }));
  }
  return /*#__PURE__*/_react["default"].createElement(_HBBaseTag["default"], baseProps);
};
var _default = exports["default"] = HBTagNew;
var THEME = {
  neutral: {
    backgroundColor: _colors["default"].neutral200,
    hoverBackgroundColor: _colors["default"].black_01,
    labelColor: 'textPrimary',
    editIconColor: 'neutral800',
    removeIconColor: 'neutral700',
    iconColor: _colors["default"].neutral900
  },
  accent: {
    backgroundColor: _colors["default"].blue20_10_hex,
    hoverBackgroundColor: _colors["default"].black_01,
    labelColor: 'blue25',
    editIconColor: 'blue25',
    removeIconColor: 'blue25',
    iconColor: _colors["default"].blue20
  }
};
//# sourceMappingURL=HBTagNew.js.map